/**
 * Escapuje XML znaky ze stringu.
 * @param input String k escapování.
 */
export const escapeXmlString = (input: string) => {
    const dom = document.createElement("div");
    dom.textContent = input;
    return dom.innerHTML;
};

/**
 * Escapované znaky XML převede na jejich ne-escapovanou verzi.
 * @param input String k de-escapování.
 */
export const unescapeXmlString = (input: string) => {
    const dom = document.createElement("textarea");
    dom.innerHTML = input;
    return dom.value;
};

/**
 * Vrací C# název typu, podle hodnoty, co je ve vstupním stringu.
 * @param value C# název typu
 */
export const getCsharpTypeFromString = (value: string): string | undefined => {
    if (value === "" || value === undefined)
        return "string";

    if (value === "true" || value === "false") // Pozor False/True se považuje za string, ne boolean!
        return "boolean";

    if (!isNaN(Number(value)))
        return value.includes(".") ? "double" : "int"; // Řešíme pouze desetinnou tečku, čárku ne.

    return "string";
};
